import config from "@/config";
import useDialog from "./Dialogs/useDialog";
import { ManufacturerModal, ModalTransition } from "@/Components";

export default function toggleManufacturerModal() {
    const { forceClose, toggleDialog } = useDialog();

    const toggleManufacturerModal = (event, data) => {
        toggleDialog(
            ManufacturerModal,
            ModalTransition,
            data,
            event,
            config.dialogs.modals.zindex,
            true
        );
    };

    return {
        forceClose,
        toggleManufacturerModal,
    };
}
